<template>
    <div class="">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-lx-copy"></i> 牌照查看</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="全部" name="first">
					<el-form ref="allLicenselyform" :model="allLicenselyform">
						<div class="apply-flex">
							<p class="apply-flexarea">
								<el-form-item label="区域" prop="provinceId">
									<el-select v-model="allLicenselyform.provinceId" placeholder="请选择省份" @change="provinceChange(allLicenselyform)" style="width:150px">
									    <el-option
									      v-for="item in provinceOptions"
									      :key="item.provinceId"
									      :label="item.name"
									      :value="item.provinceId">
									    </el-option>
									  </el-select>
								</el-form-item>
								<el-form-item label="" prop="cityId">
									<el-select v-model="allLicenselyform.cityId" placeholder="请选择市区" style="width:150px">
									    <el-option
									      v-for="item in citysOptions"
									      :key="item.cityId"
									      :label="item.name"
									      :value="item.cityId">
									    </el-option>
									  </el-select>
								</el-form-item>
							</p>
							<p>
								<el-form-item label="牌照编号"  prop='equipmentCode'>
									<el-input v-model="allLicenselyform.equipmentCode" style="width:150px"></el-input>
								</el-form-item>
							</p>
							<p>
								<el-form-item label="车主姓名"  prop='ownerName'>
									<el-input v-model="allLicenselyform.ownerName" style="width:150px"></el-input>
								</el-form-item>
							</p>
							
							<p class="apply-flexarea">
								<el-form-item label="选择日期"  prop='startendDate'>
									<el-date-picker
										style="width:300px"
										class="flex-rt"
										  v-model="allLicenselyform.startendDate"
										  unlink-panels
										  type="daterange"
										  value-format='yyyy-MM-dd'
										  range-separator="至"
										  start-placeholder="开始日期"
										  end-placeholder="结束日期">
										</el-date-picker>
								</el-form-item>
							</p>
							<p>
								<el-form-item label="机械类型"  prop='machineryType'>
									<el-input v-model="allLicenselyform.machineryType" style="width:150px"></el-input>
								</el-form-item>
							</p>
							
							<p>
								<el-form-item label="打印状态"  prop='dayinzhuangtai'>
									<el-select v-model="allLicenselyform.dayinzhuangtai" placeholder="请选择打印状态">
										<el-option label="已打印" value="2"></el-option>
										<el-option label="未打印" value="1"></el-option>
									  </el-select>
								</el-form-item>
							</p>
							
							<p class="apply-flexarea">
								<el-form-item label="出厂日期"  prop='startendProductionDate'>
									<el-date-picker
										style="width:300px"
										class="flex-rt"
										  v-model="allLicenselyform.startendProductionDate"
										  unlink-panels
										  type="daterange"
										  value-format='yyyy-MM-dd'
										  range-separator="至"
										  start-placeholder="开始日期"
										  end-placeholder="结束日期">
										</el-date-picker>
								</el-form-item>
							</p>
							
						</div>
					</el-form>	
					
					<p class="flex-btn">
						<el-button type="primary" icon="el-icon-search" @click="handleSearch(allLicenselyform,'')">搜索</el-button>
						<!-- <el-button
							type="primary"
							icon="el-icon-printer"
							class="handle-del"
							@click="listPrintFileLicense(allLicenselyform,'','first')"
						>批量打印</el-button> -->
						<el-button
							type="primary"
							icon="el-icon-printer"
							class="handle-del"
							@click="listPrintMechanicalPictures()"
						>打印车辆图片</el-button>
					</p>
					
                    <el-table
                        :data="allLicenselyTableData"
                        border
                        class="table"
                        ref="multipleTable"
                        header-cell-class-name="table-header"
                        @selection-change="handleSelectionChange"
                    >
                        <el-table-column type="selection" width="55" align="center"></el-table-column>
                        <el-table-column prop="areaName" label="区域" align="center"></el-table-column>
                        <el-table-column prop="ownerName" label="车主姓名"></el-table-column>
						<el-table-column prop="machineryType" label="机械类型" align="center"></el-table-column>
						<el-table-column prop="equipmentCode" label="设备编码"></el-table-column>
						<el-table-column prop="engineNumber" label="发动机号" align="center"></el-table-column>
						<el-table-column prop="fuelType" label="燃油类型"></el-table-column>
						<el-table-column prop="createTimeStr" label="申请日期" align="center"></el-table-column>
						<el-table-column prop="dayinzhuangtaiStr" label="打印状态"></el-table-column>
						<el-table-column prop="applicantName" label="业务员姓名" align="center"></el-table-column>
                        <el-table-column label="操作" width="260" align="center">
                            <template slot-scope="scope">
								
                                <el-button
                                    type="text"
                                    icon="el-icon-view"
                                >
								<router-link :to="'/seelicenseapplys/'+scope.row.licenseApplyId + '/'+activeName + '/' +query.pageIndex" style="color: #409EFF;">
								查看
								</router-link>
								</el-button>
								<el-button
								    type="text"
								    icon="el-icon-delete"
								    @click="handleDelete(allLicenselyform,'',scope.row,'first')"
								>删除</el-button>
                                <el-button
                                    type="text"
                                    icon="el-icon-printer"
                                    @click="getprintFileLicense(allLicenselyform,'',scope.row,'first')"
                                >设备档案打印</el-button>
								<el-button
								    type="text"
								    icon="el-icon-printer"
								    @click="getprintFileLicenseZhengFuBen(allLicenselyform,'',scope.row,'first')"
								>登记证正副本打印</el-button>
								<el-button
								    type="text"
								    icon="el-icon-printer"
								    @click="getprintFileLicenseZhengBen(allLicenselyform,'',scope.row,'first')"
								>登记证正本打印</el-button>
								<el-button
								    type="text"
								    icon="el-icon-printer"
								    @click="getprintFileLicenseFuBen(allLicenselyform,'',scope.row,'first')"
								>登记证副本打印</el-button>
								
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination">
                        <el-pagination
                            background
                            layout="total, prev, pager, next"
                            :current-page="query.pageIndex * 1"
                            :page-size="query.pageSize"
                            :total="pageTotal"
                            @current-change="handlePageChange($event,allLicenselyform,'')"
                        ></el-pagination>
                    </div>
					
					
                </el-tab-pane>
                <el-tab-pane label="小程序用户牌照申请" name="second">
					<el-form ref="secondLicenselyform" :model="secondLicenselyform" class="apply-flex">
						<div class="apply-flex"> 
							<p>
								<el-form-item label="业务员"  prop='applicantName'>
									<el-input v-model="secondLicenselyform.applicantName"></el-input>
								</el-form-item>
							</p>
							<p>
								<el-form-item label="车主姓名"  prop='ownerName'>
									<el-input v-model="secondLicenselyform.ownerName"></el-input>
								</el-form-item>
							</p>
							<p class="apply-flexarea">
								<el-form-item label="区域" prop="provinceId">
									<el-select v-model="secondLicenselyform.provinceId" placeholder="请选择省份" @change="provinceChange(secondLicenselyform)">
									    <el-option
									      v-for="item in provinceOptions"
									      :key="item.provinceId"
									      :label="item.name"
									      :value="item.provinceId">
									    </el-option>
									  </el-select>
								</el-form-item>
								<el-form-item label="" prop="cityId">
									<el-select v-model="secondLicenselyform.cityId" placeholder="请选择市区">
									    <el-option
									      v-for="item in citysOptions"
									      :key="item.cityId"
									      :label="item.name"
									      :value="item.cityId">
									    </el-option>
									  </el-select>
								</el-form-item>
							</p>
							<p>
								<el-form-item label="打印状态"  prop='dayinzhuangtai'>
									<el-select v-model="secondLicenselyform.dayinzhuangtai" placeholder="请选择打印状态">
										<el-option label="已打印" value="2"></el-option>
										<el-option label="未打印" value="1"></el-option>
									  </el-select>
								</el-form-item>
							</p>
							
							
							<p>
								<el-form-item label="机械类型"  prop='machineryType'>
									<el-input v-model="secondLicenselyform.machineryType"></el-input>
								</el-form-item>
							</p>
							<p class="apply-flexarea">
								<el-form-item label="出厂日期"  prop='startendProductionDate'>
									<el-date-picker
										style="width:300px"
										class="flex-rt"
										  v-model="secondLicenselyform.startendProductionDate"
										  unlink-panels
										  type="daterange"
										  value-format='yyyy-MM-dd'
										  range-separator="至"
										  start-placeholder="开始日期"
										  end-placeholder="结束日期">
										</el-date-picker>
								</el-form-item>
							</p>		
						</div>	
					</el-form>	
					
					<p class="flex-btn">
						<el-button type="primary" icon="el-icon-search" @click="handleSearch(secondLicenselyform,'5')">搜索</el-button>
						<!-- <el-button
							type="primary"
							icon="el-icon-printer"
							class="handle-del"
							@click="listPrintFileLicense(secondLicenselyform,'5','second')"
						>批量打印</el-button> -->
						<el-button
							type="primary"
							icon="el-icon-printer"
							class="handle-del"
							@click="listPrintMechanicalPictures()"
						>打印车辆图片</el-button>
					</p>
					
                    <el-table
                        :data="allLicenselyTableData"
                        border
                        class="table"
                        ref="multipleTable"
                        header-cell-class-name="table-header"
                        @selection-change="handleSelectionChange"
                    >
                        <el-table-column type="selection" width="55" align="center"></el-table-column>
                        <el-table-column prop="areaName" label="区域" align="center"></el-table-column>
                        <el-table-column prop="ownerName" label="车主姓名"></el-table-column>
                    	<el-table-column prop="machineryType" label="机械类型" align="center"></el-table-column>
                    	<el-table-column prop="equipmentCode" label="设备编码"></el-table-column>
                    	<el-table-column prop="engineNumber" label="发动机号" align="center"></el-table-column>
                    	<el-table-column prop="fuelType" label="燃油类型"></el-table-column>
                    	<el-table-column prop="createTimeStr" label="申请日期" align="center"></el-table-column>
                    	<el-table-column prop="dayinzhuangtaiStr" label="打印状态"></el-table-column>
                    	<el-table-column prop="applicantName" label="业务员姓名" align="center"></el-table-column>
                        <el-table-column label="操作" width="260" align="center">
                            <template slot-scope="scope">
                               <el-button
                                   type="text"
                                   icon="el-icon-view"
                               >
                              <!-- <router-link :to="'/seelicenseapplys/'+scope.row.licenseApplyId" style="color: #409EFF;">
                               查看
                               </router-link> -->
							   <router-link :to="'/seelicenseapplys/'+scope.row.licenseApplyId + '/'+activeName + '/' +query.pageIndex" style="color: #409EFF;">
							   查看
							   </router-link>
                               </el-button>
							   <el-button
							       type="text"
							       icon="el-icon-delete"
							       @click="handleDelete(secondLicenselyform,5,scope.row,'second')"
							   >删除</el-button>
                                <el-button
                                    type="text"
                                    icon="el-icon-printer"
                                    @click="getprintFileLicense(secondLicenselyform,5,scope.row,'second')"
                                >设备档案打印</el-button>
								<el-button
								    type="text"
								    icon="el-icon-printer"
								    @click="getprintFileLicenseZhengFuBen(allLicenselyform,'',scope.row,'first')"
								>登记证正副本打印</el-button>
								<el-button
								    type="text"
								    icon="el-icon-printer"
								    @click="getprintFileLicenseZhengBen(secondLicenselyform,5,scope.row,'second')"
								>登记证正本打印</el-button>
								<el-button
								    type="text"
								    icon="el-icon-printer"
								    @click="getprintFileLicenseFuBen(secondLicenselyform,5,scope.row,'second')"
								>登记证副本打印</el-button>
								
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination">
                        <el-pagination
                            background
                            layout="total, prev, pager, next"
                            :current-page="query.pageIndex * 1"
                            :page-size="query.pageSize"
                            :total="pageTotal"
                            @current-change="handlePageChange($event,secondLicenselyform,'5')"
                        ></el-pagination>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="分支机构牌照申请" name="third">
					<el-form ref="thirdLicenselyform" :model="thirdLicenselyform" class="apply-flex">
						<div class="apply-flex"> 
							<p>
								<el-form-item label="分支机构"  prop='applicantOrganizationName'>
									<el-input v-model="thirdLicenselyform.applicantOrganizationName"></el-input>
								</el-form-item>
							</p>
							<p>
								<el-form-item label="车主姓名"  prop='ownerName'>
									<el-input v-model="thirdLicenselyform.ownerName"></el-input>
								</el-form-item>
							</p>
							<p class="apply-flexarea">
								<el-form-item label="区域" prop="provinceId">
									<el-select v-model="thirdLicenselyform.provinceId" placeholder="请选择省份" @change="provinceChange(thirdLicenselyform)">
									    <el-option
									      v-for="item in provinceOptions"
									      :key="item.provinceId"
									      :label="item.name"
									      :value="item.provinceId">
									    </el-option>
									  </el-select>
								</el-form-item>
								<el-form-item label="" prop="cityId">
									<el-select v-model="thirdLicenselyform.cityId" placeholder="请选择市区">
									    <el-option
									      v-for="item in citysOptions"
									      :key="item.cityId"
									      :label="item.name"
									      :value="item.cityId">
									    </el-option>
									  </el-select>
								</el-form-item>
							</p>
							<p>
								<el-form-item label="打印状态"  prop='dayinzhuangtai'>
									<el-select v-model="thirdLicenselyform.dayinzhuangtai" placeholder="请选择打印状态">
										<el-option label="已打印" value="2"></el-option>
										<el-option label="未打印" value="1"></el-option>
									  </el-select>
								</el-form-item>
							</p>
							<p>
								<el-form-item label="机械类型"  prop='machineryType'>
									<el-input v-model="thirdLicenselyform.machineryType"></el-input>
								</el-form-item>
							</p>
							<p class="apply-flexarea">
								<el-form-item label="出厂日期"  prop='startendProductionDate'>
									<el-date-picker
										style="width:300px"
										class="flex-rt"
										  v-model="thirdLicenselyform.startendProductionDate"
										  unlink-panels
										  type="daterange"
										  value-format='yyyy-MM-dd'
										  range-separator="至"
										  start-placeholder="开始日期"
										  end-placeholder="结束日期">
										</el-date-picker>
								</el-form-item>
							</p>
						</div>
						
						
					</el-form>	
					
					<p class="flex-btn">
						<el-button type="primary" icon="el-icon-search" @click="handleSearch(thirdLicenselyform,'3')">搜索</el-button>
						<!-- <el-button
							type="primary"
							icon="el-icon-printer"
							class="handle-del"
							@click="listPrintFileLicense(thirdLicenselyform,'3','third')" 
						>批量打印</el-button> -->
						<el-button
							type="primary"
							icon="el-icon-printer"
							class="handle-del"
							@click="listPrintMechanicalPictures()"
						>打印车辆图片</el-button>
					</p>
					
                    <el-table
                        :data="allLicenselyTableData"
                        border
                        class="table"
                        ref="multipleTable"
                        header-cell-class-name="table-header"
                        @selection-change="handleSelectionChange"
                    >
                        <el-table-column type="selection" width="55" align="center"></el-table-column>
                        <el-table-column prop="areaName" label="区域" align="center"></el-table-column>
                        <el-table-column prop="ownerName" label="车主姓名"></el-table-column>
                    	<el-table-column prop="machineryType" label="机械类型" align="center"></el-table-column>
                    	<el-table-column prop="equipmentCode" label="设备编码"></el-table-column>
                    	<el-table-column prop="engineNumber" label="发动机号" align="center"></el-table-column>
                    	<el-table-column prop="fuelType" label="燃油类型"></el-table-column>
                    	<el-table-column prop="createTimeStr" label="申请日期" align="center"></el-table-column>
						<el-table-column prop="applicantOrganizationName" label="机构名称" align="center"></el-table-column>
                    	<el-table-column prop="dayinzhuangtaiStr" label="打印状态"></el-table-column>
                    	
                        <el-table-column label="操作" width="260" align="center">
                            <template slot-scope="scope">
                                <el-button
                                    type="text"
                                    icon="el-icon-view"
                                >
                                <router-link :to="`/seeLicenseapplysfzorgan/${scope.row.licenseApplyId}/${query.pageIndex}/${activeName}`" style="color: #409EFF;">
                                查看
								
                                </router-link>
                                </el-button>
								<el-button
								    type="text"
								    icon="el-icon-delete"
								    @click="handleDelete(thirdLicenselyform,'3',scope.row,'third')"
								>删除</el-button>
                                <el-button
                                    type="text"
                                    icon="el-icon-printer"
                                    @click="getprintFileLicense(thirdLicenselyform,'3',scope.row,'third')"
                                >设备档案打印</el-button>
								<el-button
								    type="text"
								    icon="el-icon-printer"
								    @click="getprintFileLicenseZhengFuBen(allLicenselyform,'',scope.row,'first')"
								>登记证正副本打印</el-button>
								<el-button
								    type="text"
								    icon="el-icon-printer"
								    @click="getprintFileLicenseZhengBen(thirdLicenselyform,'3',scope.row,'third')"
								>登记证正本打印</el-button>
								<el-button
								    type="text"
								    icon="el-icon-printer"
								    @click="getprintFileLicenseFuBen(thirdLicenselyform,'3',scope.row,'third')"
								>登记证副本打印</el-button>
								
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination">
                        <el-pagination
                            background
                            layout="total, prev, pager, next"
                            :current-page="query.pageIndex * 1"
                            :page-size="query.pageSize"
                            :total="pageTotal"
                            @current-change="handlePageChange($event,thirdLicenselyform,'3')"
                        ></el-pagination>
                    </div>
                </el-tab-pane>
				<el-tab-pane label="总部业务员牌照申请" name="fourth">
					<el-form ref="fourthLicenselyform" :model="fourthLicenselyform" class="apply-flex">
						<div class="apply-flex"> 
							<p>
								<el-form-item label="业务员"  prop='applicantName'>
									<el-input v-model="fourthLicenselyform.applicantName"></el-input>
								</el-form-item>
							</p>
							<p>
								<el-form-item label="车主姓名"  prop='ownerName'>
									<el-input v-model="fourthLicenselyform.ownerName"></el-input>
								</el-form-item>
							</p>
							<p class="apply-flexarea">
								<el-form-item label="区域" prop="provinceId">
									<el-select v-model="fourthLicenselyform.provinceId" placeholder="请选择省份" @change="provinceChange(fourthLicenselyform)">
									    <el-option
									      v-for="item in provinceOptions"
									      :key="item.provinceId"
									      :label="item.name"
									      :value="item.provinceId">
									    </el-option>
									  </el-select>
								</el-form-item>
								<el-form-item label="" prop="cityId">
									<el-select v-model="fourthLicenselyform.cityId" placeholder="请选择市区">
									    <el-option
									      v-for="item in citysOptions"
									      :key="item.cityId"
									      :label="item.name"
									      :value="item.cityId">
									    </el-option>
									  </el-select>
								</el-form-item>
							</p>
							<p>
								<el-form-item label="打印状态"  prop='dayinzhuangtai'>
									<el-select v-model="fourthLicenselyform.dayinzhuangtai" placeholder="请选择打印状态">
										<el-option label="已打印" value="2"></el-option>
										<el-option label="未打印" value="1"></el-option>
									  </el-select>
								</el-form-item>
							</p>
							<p>
								<el-form-item label="机械类型"  prop='machineryType'>
									<el-input v-model="fourthLicenselyform.machineryType"></el-input>
								</el-form-item>
							</p>
							<p class="apply-flexarea">
								<el-form-item label="出厂日期"  prop='startendProductionDate'>
									<el-date-picker
										style="width:300px"
										class="flex-rt"
										  v-model="fourthLicenselyform.startendProductionDate"
										  unlink-panels
										  type="daterange"
										  value-format='yyyy-MM-dd'
										  range-separator="至"
										  start-placeholder="开始日期"
										  end-placeholder="结束日期">
										</el-date-picker>
								</el-form-item>
							</p>
						</div>
						
						
					</el-form>	
					
					<p class="flex-btn">
						<el-button type="primary" icon="el-icon-search" @click="handleSearch(fourthLicenselyform,'2')">搜索</el-button>
						<!-- <el-button
							type="primary"
							icon="el-icon-printer"
							class="handle-del"
							@click="listPrintFileLicense(fourthLicenselyform,'2','fourth')"
						>批量打印</el-button> -->
						<el-button
							type="primary"
							icon="el-icon-document-add"
							class="handle-del"
						>
							<router-link :to="`/addlicense/${activeName}/${query.pageIndex}`" style="color: #fff;">
								添加牌照
							</router-link>
						</el-button>
						<el-button
							type="primary"
							icon="el-icon-printer"
							class="handle-del"
							@click="listPrintMechanicalPictures()"
						>打印车辆图片</el-button>
						
					</p>
					
				   <el-table
				       :data="allLicenselyTableData"
				       border
				       class="table"
				       ref="multipleTable"
				       header-cell-class-name="table-header"
				       @selection-change="handleSelectionChange"
				   >
				       <el-table-column type="selection" width="55" align="center"></el-table-column>
				       <el-table-column prop="areaName" label="区域" align="center"></el-table-column>
				       <el-table-column prop="ownerName" label="车主姓名"></el-table-column>
				   	<el-table-column prop="machineryType" label="机械类型" align="center"></el-table-column>
				   	<el-table-column prop="equipmentCode" label="设备编码"></el-table-column>
				   	<el-table-column prop="engineNumber" label="发动机号" align="center"></el-table-column>
				   	<el-table-column prop="fuelType" label="燃油类型"></el-table-column>
				   	<el-table-column prop="createTimeStr" label="申请日期" align="center"></el-table-column>
				   	<el-table-column prop="dayinzhuangtaiStr" label="打印状态"></el-table-column>
				   	<el-table-column prop="applicantName" label="业务员姓名" align="center"></el-table-column>
				       <el-table-column label="操作" width="260" align="center">
				           <template slot-scope="scope">
				               <el-button
				                   type="text"
				                   icon="el-icon-view"
				               >
				               <router-link :to="'/seeLicenseapplyszbjx/'+scope.row.licenseApplyId + '/' +activeName+ '/' +query.pageIndex " style="color: #409EFF;">
				               查看
				               </router-link>
				               </el-button>
							   <el-button
							       type="text"
							       icon="el-icon-delete"
							       @click="handleDelete(fourthLicenselyform,'2',scope.row,'fourth')"
							   >删除</el-button>
				               <el-button
				                   type="text"
				                   icon="el-icon-printer"
				                   @click="getprintFileLicense(fourthLicenselyform,'2',scope.row,'fourth')"
				               >设备档案打印</el-button>
							   <el-button
								    type="text"
								    icon="el-icon-printer"
								    @click="getprintFileLicenseZhengFuBen(allLicenselyform,'',scope.row,'first')"
								>登记证正副本打印</el-button>
							   <el-button
							       type="text"
							       icon="el-icon-printer"
							       @click="getprintFileLicenseZhengBen(fourthLicenselyform,'2',scope.row,'fourth')"
							   >登记证正本打印</el-button>
							   <el-button
							       type="text"
							       icon="el-icon-printer"
							       @click="getprintFileLicenseFuBen(fourthLicenselyform,'2',scope.row,'fourth')"
							   >登记证副本打印</el-button>
							   
				           </template>
				       </el-table-column>
				   </el-table>
				   <div class="pagination">
				       <el-pagination
				           background
				           layout="total, prev, pager, next"
				           :current-page="query.pageIndex * 1"
				           :page-size="query.pageSize"
				           :total="pageTotal"
				           @current-change="handlePageChange($event,fourthLicenselyform,'2')"
				       ></el-pagination>
				   </div>
				</el-tab-pane>
				<el-tab-pane label="厂商业务员牌照申请" name="fifth">
					<el-form ref="fifthLicenselyform" :model="fifthLicenselyform" class="apply-flex">
						<div class="apply-flex"> 
							<p>
								<el-form-item label="业务员"  prop='applicantName'>
									<el-input v-model="fifthLicenselyform.applicantName"></el-input>
								</el-form-item>
							</p>
							<p>
								<el-form-item label="车主姓名"  prop='ownerName'>
									<el-input v-model="fifthLicenselyform.ownerName"></el-input>
								</el-form-item>
							</p>
							<p class="apply-flexarea">
								<el-form-item label="区域" prop="provinceId">
									<el-select v-model="fifthLicenselyform.provinceId" placeholder="请选择省份" @change="provinceChange(fifthLicenselyform)">
									    <el-option
									      v-for="item in provinceOptions"
									      :key="item.provinceId"
									      :label="item.name"
									      :value="item.provinceId">
									    </el-option>
									  </el-select>
								</el-form-item>
								<el-form-item label="" prop="cityId">
									<el-select v-model="fifthLicenselyform.cityId" placeholder="请选择市区">
									    <el-option
									      v-for="item in citysOptions"
									      :key="item.cityId"
									      :label="item.name"
									      :value="item.cityId">
									    </el-option>
									  </el-select>
								</el-form-item>
							</p>
							<p>
								<el-form-item label="打印状态"  prop='dayinzhuangtai'>
									<el-select v-model="fifthLicenselyform.dayinzhuangtai" placeholder="请选择打印状态">
										<el-option label="已打印" value="2"></el-option>
										<el-option label="未打印" value="1"></el-option>
									  </el-select>
								</el-form-item>
							</p>
							<p>
								<el-form-item label="机械类型"  prop='machineryType'>
									<el-input v-model="fifthLicenselyform.machineryType"></el-input>
								</el-form-item>
							</p>
							<p class="apply-flexarea">
								<el-form-item label="出厂日期"  prop='startendProductionDate'>
									<el-date-picker
										style="width:300px"
										class="flex-rt"
										  v-model="fifthLicenselyform.startendProductionDate"
										  unlink-panels
										  type="daterange"
										  value-format='yyyy-MM-dd'
										  range-separator="至"
										  start-placeholder="开始日期"
										  end-placeholder="结束日期">
										</el-date-picker>
								</el-form-item>
							</p>
						</div>
						
						
					</el-form>	
					
					<p class="flex-btn">
						<el-button type="primary" icon="el-icon-search" @click="handleSearch(fifthLicenselyform,'4')">搜索</el-button>
						<!-- <el-button
							type="primary"
							icon="el-icon-printer"
							class="handle-del"
							@click="listPrintFileLicense(fifthLicenselyform,'4','fifth')"
						>批量打印</el-button> -->
						<el-button
							type="primary"
							icon="el-icon-printer"
							class="handle-del"
							@click="listPrintMechanicalPictures()"
						>打印车辆图片</el-button>
					</p>
					
				  <el-table
				      :data="allLicenselyTableData"
				      border
				      class="table"
				      ref="multipleTable"
				      header-cell-class-name="table-header"
				      @selection-change="handleSelectionChange"
				  >
				      <el-table-column type="selection" width="55" align="center"></el-table-column>
				      <el-table-column prop="areaName" label="区域" align="center"></el-table-column>
				      <el-table-column prop="ownerName" label="车主姓名"></el-table-column>
				  	<el-table-column prop="machineryType" label="机械类型" align="center"></el-table-column>
				  	<el-table-column prop="equipmentCode" label="设备编码"></el-table-column>
				  	<el-table-column prop="engineNumber" label="发动机号" align="center"></el-table-column>
				  	<el-table-column prop="fuelType" label="燃油类型"></el-table-column>
				  	<el-table-column prop="createTimeStr" label="申请日期" align="center"></el-table-column>
				  	<el-table-column prop="dayinzhuangtaiStr" label="打印状态"></el-table-column>
				  	<el-table-column prop="applicantName" label="业务员姓名" align="center"></el-table-column>
				      <el-table-column label="操作" width="260" align="center">
				          <template slot-scope="scope">
				              <el-button
				                  type="text"
				                  icon="el-icon-view"
				              >
				             <router-link :to="'/seeLicenseapplyszbjx/'+scope.row.licenseApplyId+'/'+activeName+'/'+query.pageIndex" style="color: #409EFF;">
				              查看
				              </router-link>
				              </el-button>
							  <el-button
							      type="text"
							      icon="el-icon-delete"
							      @click="handleDelete(fifthLicenselyform,'4',scope.row,'fifth')"
							  >删除</el-button>
				              <el-button
				                  type="text"
				                  icon="el-icon-printer"
				                  @click="getprintFileLicense(fifthLicenselyform,'4',scope.row,'fifth')"
				              >设备档案打印</el-button>
							  <el-button
								    type="text"
								    icon="el-icon-printer"
								    @click="getprintFileLicenseZhengFuBen(allLicenselyform,'',scope.row,'first')"
								>登记证正副本打印</el-button>
							  <el-button
							      type="text"
							      icon="el-icon-printer"
							      @click="getprintFileLicenseZhengBen(fifthLicenselyform,'4',scope.row,'fifth')"
							  >登记证正本打印</el-button>
							  <el-button
							      type="text"
							      icon="el-icon-printer"
							      @click="getprintFileLicenseFuBen(fifthLicenselyform,'4',scope.row,'fifth')"
							  >登记证副本打印</el-button>
							  
				          </template>
				      </el-table-column>
				  </el-table>
				  <div class="pagination">
				      <el-pagination
				          background
				          layout="total, prev, pager, next"
				          :current-page="query.pageIndex"
				          :page-size="query.pageSize"
				          :total="pageTotal"
				          @current-change="handlePageChange($event,fifthLicenselyform,'4')"
				      ></el-pagination>
				  </div>
				</el-tab-pane>
				
            </el-tabs>
        </div>
    </div>
</template>

<script>
	import {listProvinces,deleteLicenseApply,listCitysByProvinceId,listLicenseApplys,printFileLicense,printLicenseApply,printFileMechanicalPictures,printFileLicenseZhengBen,printFileLicenseFuBen,printFileLicenseZhengFuBen} from '../api/index';
    export default {
        name: 'licenseapplys',
        data() {
            return {
				val:1,//分页页码数
                activeName: 'first',
				provinceOptions:[],  //省列表
				citysOptions:[],   //市列表
				allLicenselyform:{
					provinceId:'',
					cityId:'',
					dayinzhuangtai:'',
					equipmentCode:'',  //牌照编号
					ownerName:'',//车主姓名
					startendDate:'',  //日期
					startendProductionDate:'',  //出厂日期
					machineryType:''  //机械类型
					
				},  //所有的搜索表单
				secondLicenselyform:{
					applicantName:'',  //业务员
					ownerName:'',//车主姓名
					provinceId:'',
					cityId:'',
					dayinzhuangtai:'',
					startendProductionDate:'',  //出厂日期
					machineryType:''  //机械类型
				},
				thirdLicenselyform:{
					applicantOrganizationName:'',  //分支机构
					ownerName:'',//车主姓名
					provinceId:'',
					cityId:'',
					dayinzhuangtai:'',
					startendProductionDate:'',  //出厂日期
					machineryType:''  //机械类型
				},
				fourthLicenselyform:{
					applicantName:'',  //业务员
					ownerName:'',//车主姓名
					provinceId:'',
					cityId:'',
					dayinzhuangtai:'',
					startendProductionDate:'',  //出厂日期
					machineryType:''  //机械类型
				},
				fifthLicenselyform:{
					applicantName:'',  //业务员
					ownerName:'',//车主姓名
					provinceId:'',
					cityId:'',
					dayinzhuangtai:'',
					startendProductionDate:'',  //出厂日期
					machineryType:''  //机械类型
				},
				query: {
				    pageIndex: this.$route.params.pageIndex,
				    pageSize: 10
				},   //分页
				allLicenselyTableData: [],
				multipleSelection: [],
				editVisible: false,
				pageTotal: 0,
            }
        },
		created() {
			this.activeName = this.$route.params.activeName;
			this.query.pageIndex = this.$route.params.pageIndex
			let organizationKind = '';
			let form = this.allLicenselyform;
		
			switch(this.activeName){
				case 'second':
					organizationKind = 5;
					form = this.secondLicenselyform;
					break;
				case 'third':
					organizationKind = 3;
					form = this.thirdLicenselyform;
					break;
				case 'fourth':
					organizationKind = 2;
					form = this.fourthLicenselyform;
					break;
				case 'fifth':
					organizationKind = 4;
					form = this.fifthLicenselyform;
					break;
			}
			var that =  this;
			// 省
			listProvinces({
			}).then(res => {
			    // 获取数据成功后的其他操作
				that.provinceOptions = res.data;
			});
		    this.getlistLicenseApplys(form,organizationKind,this.$route.params.pageIndex);  //初始化form为全部allLicenselyform
		},
        methods: {
			// 省改变请求市
			provinceChange(Licenselyform){
				Licenselyform.cityId = '';
				listCitysByProvinceId({
					provinceId:Licenselyform.provinceId
				}).then(res => {
				    // 获取数据成功后的其他操作
					this.citysOptions = res.data;
				});
			},
			// 获取数据列表
			// 获取 easy-mock 的模拟数据
			// getlistLicenseApplys() {
			//     listLicenseApplys({
			//     	current: this.query.pageIndex,                    
			//     	size: this.query.pageSize                
			//     }).then(res => {
			//         // 获取数据成功后的其他操作
			//     	this.allLicenselyTableData = res.data.records;
			//     });
			// },
			getlistLicenseApplys(form,organizationKind,current) {
				var LicenseApplyobj = {};
				if(form.startendDate){
					form.startDate = form.startendDate[0];
					form.endDate = form.startendDate[1];
				}
				// 出产日期处理
				if(form.startendProductionDate){
					form.startProductionDate = form.startendProductionDate[0];
					form.endProductionDate = form.startendProductionDate[1];
				}
				LicenseApplyobj = form;
				LicenseApplyobj.organizationKind = organizationKind;
				LicenseApplyobj.current = current;
				LicenseApplyobj.size = this.query.pageSize;
			    listLicenseApplys(LicenseApplyobj).then(res => {
			        // 获取数据成功后的其他操作
			    	this.allLicenselyTableData = res.data.records;
					this.pageTotal = res.data.total;
			    });
			},
		
			
            handleClick(tab, event) {
				this.val = 1
				this.allLicenselyform = {
					provinceId:'',
					cityId:'',
					equipmentCode:'',  //牌照编号
					ownerName:'',//车主姓名
					startendDate:''  ,//日期
					startendProductionDate:'',  //出厂日期
					machineryType:''  //机械类型
				}; 
				this.secondLicenselyform = {
					applicantName:'',  //业务员
					ownerName:'',//车主姓名
					provinceId:'',
					cityId:'',
					dayinzhuangtai:'',
					startendProductionDate:'',  //出厂日期
					machineryType:''  //机械类型
				};
				this.thirdLicenselyform={
					applicantOrganizationName:'',  //分支机构
					ownerName:'',//车主姓名
					provinceId:'',
					cityId:'',
					dayinzhuangtai:'',
					startendProductionDate:'',  //出厂日期
					machineryType:''  //机械类型
				};
				this.fourthLicenselyform={
					applicantName:'',  //业务员
					ownerName:'',//车主姓名
					provinceId:'',
					cityId:'',
					dayinzhuangtai:'',
					startendProductionDate:'',  //出厂日期
					machineryType:''  //机械类型
				};
				this.fifthLicenselyform={
					applicantName:'',  //业务员
					ownerName:'',//车主姓名
					provinceId:'',
					cityId:'',
					dayinzhuangtai:'',
					startendProductionDate:'',  //出厂日期
					machineryType:''  //机械类型
				};
				this.allLicenselyTableData = [];
				var organizationKind = '';
				if(tab.name == 'first'){
					organizationKind = '';
				}else if(tab.name == 'second'){
					organizationKind = 5;
				}else if(tab.name == 'third'){
					organizationKind = 3;
				}else if(tab.name == 'fourth'){
					organizationKind = 2;
				}else if(tab.name == 'fifth'){
					organizationKind = 4;
				}
				this.query.pageIndex = 1;
				this.getlistLicenseApplys({},organizationKind,1);
            },
			
			// 删除操作
			handleDelete(form,organizationKind,row,activeName) {
			    // 二次确认删除
			    this.$confirm('确定要删除吗？', '提示', {
			        type: 'warning'
			    }).then(() => {
					deleteLicenseApply({
						 "licenseApplyId": row.licenseApplyId
					}).then(res => {
						this.activeName = activeName;
						this.getlistLicenseApplys(form,organizationKind,1);
						if(res.code == 0){
						  // 获取数据成功后的其他操作
							this.$message({
							  message: res.message,
							  type: 'success'
							});
						}else if(res.code == 1){
							  this.$message({
								message: res.message,
								type: 'warning'
							  });
						}else{
							  this.$message({
								message: '报错啦!',
								type: 'warning'
							  });
						}
						
					});
				}).catch(() => {});
			},
			
			// 触发搜索按钮
			handleSearch(form,organizationKind) {
				this.getlistLicenseApplys(form,organizationKind,1);
			},
			// 删除操作
			
			// 多选操作
			handleSelectionChange(val) {
				console.log(val)
			    this.multipleSelection = val;
			},
			delAllSelection() {
			    
			},
			// 编辑操作
			handleEdit(index, row) {
			    this.idx = index;
			    this.form = row;
			    this.editVisible = true;
			},
			// 保存编辑
			saveEdit() {
			    this.editVisible = false;
			    this.$message.success(`修改第 ${this.idx + 1} 行成功`);
			    this.$set(this.tableData, this.idx, this.form);
			},
			// 分页导航
			handlePageChange(val,form,kind) {
				this.val = val
				console.log(val)
				console.log(form)
				console.log(form,kind),
				
				console.log(this.query)
			    this.$set(this.query, 'pageIndex', val);
			    this.getlistLicenseApplys(form,kind,val);
			},
			
			getprintFileLicense(form,organizationKind,row,activeName){
				row.mechanicalPictures2 = '/api/static' + row.mechanicalPictures;
				printFileLicense(row);
				printLicenseApply({
					"licenseApplyIds":row.licenseApplyId
				}).then(res => {
				    // 获取数据成功后的其他操作
						this.activeName = activeName;
						this.getlistLicenseApplys(form,organizationKind,this.val);
						this.$message({
						  message: res.message,
						  type: 'success'
						});
					})
			},
			// 
			getprintFileLicenseZhengFuBen(form,organizationKind,row,activeName){
				printFileLicenseZhengFuBen(row);
				printLicenseApply({
					"licenseApplyIds":row.licenseApplyId
				}).then(res => {
				    // 获取数据成功后的其他操作
						this.activeName = activeName;
						this.getlistLicenseApplys(form,organizationKind,this.val);
						this.$message({
						  message: res.message,
						  type: 'success'
						});
					})
			},
			// 登记证正本打印
			getprintFileLicenseZhengBen(form,organizationKind,row,activeName){
				printFileLicenseZhengBen(row);
				printLicenseApply({
					"licenseApplyIds":row.licenseApplyId
				}).then(res => {
				    // 获取数据成功后的其他操作
						this.activeName = activeName;
						this.getlistLicenseApplys(form,organizationKind,this.val);
						this.$message({
						  message: res.message,
						  type: 'success'
						});
					})
			},
			
			// 登记证副本打印
			getprintFileLicenseFuBen(form,organizationKind,row,activeName){
				printFileLicenseFuBen(row);
				printLicenseApply({
					"licenseApplyIds":row.licenseApplyId
				}).then(res => {
				    // 获取数据成功后的其他操作
						this.activeName = activeName;
						this.getlistLicenseApplys(form,organizationKind,this.val);
						this.$message({
						  message: res.message,
						  type: 'success'
						});
					})
			},
			
			// 批量打印
			listPrintFileLicense(form,organizationKind,activeName){
				// 获取选中的行记录
				// console.log(this.multipleSelection);
				var licenseApplyId = '';
				for(var i in this.multipleSelection){
					var obj2 = this.multipleSelection[i];
					obj2.mechanicalPictures2 = '/api/static' + obj2.mechanicalPictures;
					printFileLicense(obj2);
					if(i==0){
						licenseApplyId += this.multipleSelection[i].licenseApplyId;
					}else {
						licenseApplyId += ',' +this.multipleSelection[i].licenseApplyId;
					}
				}
				// console.log(licenseApplyId);
				printLicenseApply({
					"licenseApplyIds":licenseApplyId
				}).then(res => {
				    // 获取数据成功后的其他操作
						this.activeName = activeName;
						this.getlistLicenseApplys(form,organizationKind,1);
						this.$message({
						  message: res.message,
						  type: 'success'
						});
					})
				
			},
			
			// 打印车辆照片
			listPrintMechanicalPictures(){
				// 获取选中的行记录
				var photoArr = [];
				var numberArr = [];
				if(this.multipleSelection.length <= 0){
					this.$message({
					  message: '没有选择打印项哦',
					  type: 'warning'
					});
					return false;
				}
				
				if(this.multipleSelection.length > 2){
					this.$message({
					  message: '最多选择2条记录哦',
					  type: 'warning'
					});
					return false;
				}
				
				for(var i in this.multipleSelection){
					if(this.multipleSelection[i].mechanicalPictures){
						// 机械图片:多张图片直接使用","分割
						var tem = this.multipleSelection[i].mechanicalPictures;
						var equipmentCode = this.multipleSelection[i].equipmentCode;
						var temArr = tem.split(",");
						for(var j in temArr){
							var photo = '/api/static' + temArr[j];
							photoArr.push(photo);
							numberArr.push(equipmentCode);
						}
					}
				}
				
				// ceshi
				/* for(var i=1;i<=2;i++){
					var photo = 'http://www.c-lodop.com/demolist/PrintSample8.jpg';
					photoArr.push(photo);
					numberArr.push("河南A1234567890");
				} */
				// ceshi
				
				var photoparams = {};
				photoparams.pics = photoArr;
				photoparams.numbers = numberArr;
				printFileMechanicalPictures(photoparams);
			}
			
			
        },
        computed: {
            
        }
    }

</script>


<style scoped>
	
	.apply-flex{
		display: flex;
		display: -webkit-flex;
		flex-wrap: wrap;
	}
	.apply-flex p{
		width: 25%;
		margin-right: 20px;
	}
	
	.apply-flex p.apply-flexarea .el-form-item{
		margin-right: 10px;
	}
	.apply-flex p.apply-flexarea{
		width: 40%;
		display: flex;
		display: -webkit-flex;
	}
	.apply-flex .el-form-item{
		display: flex;
		display: -webkit-flex;
	}

	
	.flex-btn {
		margin-bottom: 20px;
		text-align: right;
		border-top: 1px solid #ddd;
		padding-top: 10px;
	}


.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>


<style>
	.apply-flex p .el-form-item__label{
		width: 80px;
	}
</style>